import { Auth0Client } from '@auth0/nextjs-auth0/server';
import { getEnv } from '@/lib/env';

export const auth0 = new Auth0Client({
  domain: getEnv('NEXT_PUBLIC_AUTH0_DOMAIN'),
  clientId: getEnv('NEXT_PUBLIC_AUTH0_CLIENT_ID'),
  appBaseUrl: getEnv('NEXT_PUBLIC_APP_BASE_URL'),
  beforeSessionSaved: async (session, idToken) => {
    return {
      ...session,
      idToken
    };
  }
});
